// FeaturedProductItem
import React, { useEffect, useState } from 'react';
import {
    updateFeaturedProductItemVisibleById,
    deleteFeaturedProductItemById,
    getFeaturedProductItemById,
    getFeaturedProductItems,
    removeProductByIds,
    searchFeaturedProductItems,
} from '../../../actions';
import { useSelector, useDispatch } from 'react-redux';
import ModalFeaturedProductItem from './ModalFeaturedProductItem';
import { MainContainer } from '../../MainContainer';
import AlertComponent from '../../../components/Alert/Alert';
import { setCloseAlertFeaturedProductItem } from '../../../reducers/featuredProductItem';
import RenderImgSliderModal from '../../../components/ProductImgSliderModal/RenderImgSliderModal';
import ModalConfirm from '../../../components/BurgerMenu/ModalConfirm';

const FeaturedProductItem = () => {
    const featuredProductItemState = useSelector((state) => state.featuredProductItem || {});

    const {
        featuredProductItems,
        featuredProductItemObj,
        variantAlert,
        showAlert,
        message,
        loading
    } = featuredProductItemState;

    const safeFeaturedProductItems = Array.isArray(featuredProductItems)
        ? featuredProductItems
        : [];

    const dispatch = useDispatch();

    const [show, setShow] = useState(false);
    const [currentId, setCurrentId] = useState(null);
    const [typeModal, setTypeModal] = useState("");
    const [currentIdPicture, setCurrentIdPicture] = useState(null);
    const [showModalImg, setShowModalImg] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(20);

    useEffect(() => {
        dispatch(getFeaturedProductItems("createdAtMinus", pageNumber, pageSize));
    }, [dispatch, pageNumber, pageSize]);

    const handleShowCreate = () => {
        setCurrentId(null);
        setTypeModal("");
        setShow(true);
    };

    const handleShowEdit = (item) => {
        if (!item?._id) return;

        setCurrentId(item._id);
        setTypeModal("");
        setShow(true);
        dispatch(getFeaturedProductItemById(item._id));
    };

    const handleShowDetails = (item) => {
        if (!item?._id) return;

        setCurrentId(item._id);
        setTypeModal("details");
        setShow(true);
        dispatch(getFeaturedProductItemById(item._id));
    };

    const handleShowProducts = (item) => {
        if (!item?._id) return;

        setCurrentId(item._id);
        setTypeModal("detailsProducts");
        setShow(true);
        dispatch(getFeaturedProductItemById(item._id));
    };

    const handleClose = () => {
        setTypeModal("");
        setShow(false);
    };

    const updateVisible = () => {
        if (currentId) {
            dispatch(updateFeaturedProductItemVisibleById(currentId));
        }
    };

    const handleShowModalImg = (pictureId) => {
        setCurrentIdPicture(pictureId);
        setShowModalImg(true);
    };

    const handleShowDeleteModal = (id) => {
        setCurrentId(id);
        setShowDeleteModal(true);
    };

    const confirmDeleteObj = () => {
        if (currentId) {
            dispatch(deleteFeaturedProductItemById(currentId));
        }

        setShowDeleteModal(false);
        setCurrentId(null);
    };

    const renderScope = (scope) => {
        switch (scope) {
            case "office":
                return "Офис";
            case "site":
            default:
                return "Сайт";
        }
    };

    return (
        <>
            <MainContainer
                backButtonProduct
                title="Товары по спискам"
                get={getFeaturedProductItems}
                search={searchFeaturedProductItems}
                handleShow={handleShowCreate}
                buttonText="Создать новый список"
                noneSelectUpdatedPictures
                sortType="createdAtMinus"
                sortSearch="name"
                typeSort="featuredProductItem"
                pageNumber={pageNumber}
                pageSize={pageSize}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
            >
                <div className="featuredProductItemAdmin">
                    <div className="featuredProductItemAdmin__top">
                        <div>
                            <h3>Списки товаров</h3>
                            <p>
                                Управление витринами сайта, будущими офисными подборками и блоками главной страницы.
                            </p>
                        </div>
                    </div>

                    <div className="featuredProductItemAdmin__table">
                        <div className="featuredProductItemAdmin__tableHead">
                            <div>Список</div>
                            <div>Тип</div>
                            <div>Область</div>
                            <div>Товары</div>
                            <div>Статус</div>
                            <div>Действия</div>
                        </div>

                        <div className="featuredProductItemAdmin__tableBody">
                            {loading ? (
                                <div className="featuredProductItemAdmin__empty">
                                    Загрузка...
                                </div>
                            ) : safeFeaturedProductItems.length > 0 ? (
                                safeFeaturedProductItems.map((item) => (
                                    <div
                                        className="featuredProductItemAdmin__row"
                                        key={item._id}
                                    >
                                        <div className="featuredProductItemAdmin__mainCell">
                                            <strong>{item.name}</strong>
                                            <span>{item.description || "Описание не заполнено"}</span>
                                        </div>

                                        <div>
                                            <span className="featuredProductItemAdmin__type">
                                                {item.type || "Без типа"}
                                            </span>
                                        </div>

                                        <div>
                                            <span className="featuredProductItemAdmin__scope">
                                                {renderScope(item.scope)}
                                            </span>
                                        </div>

                                        <div>
                                            <span className="featuredProductItemAdmin__count">
                                                {Array.isArray(item.products) ? item.products.length : 0}
                                            </span>
                                        </div>

                                        <div>
                                            <button
                                                type="button"
                                                className={item.visible
                                                    ? "featuredProductItemAdmin__visible active"
                                                    : "featuredProductItemAdmin__visible"
                                                }
                                                onClick={() => {
                                                    setCurrentId(item._id);
                                                    dispatch(updateFeaturedProductItemVisibleById(item._id));
                                                }}
                                            >
                                                {item.visible ? "Видимый" : "Скрыт"}
                                            </button>
                                        </div>

                                        <div className="featuredProductItemAdmin__actions">
                                            <button
                                                type="button"
                                                onClick={() => handleShowDetails(item)}
                                            >
                                                Детали
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() => handleShowProducts(item)}
                                            >
                                                Товары
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() => handleShowEdit(item)}
                                            >
                                                Править
                                            </button>

                                            <button
                                                type="button"
                                                className="danger"
                                                onClick={() => handleShowDeleteModal(item._id)}
                                            >
                                                Удалить
                                            </button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="featuredProductItemAdmin__empty">
                                    Списки не найдены
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <ModalFeaturedProductItem
                    updateVisible={updateVisible}
                    handleShowModalImg={handleShowModalImg}
                    setTypeModal={setTypeModal}
                    featuredProductItemObj={featuredProductItemObj || {}}
                    typeModal={typeModal}
                    handleClose={handleClose}
                    show={show}
                    currentId={currentId}
                    setCurrentId={setCurrentId}
                />
            </MainContainer>

            <AlertComponent
                dispatchCloseAlert={setCloseAlertFeaturedProductItem}
                color={variantAlert || "success"}
                showObj={showAlert}
                text={message}
            />

            <RenderImgSliderModal
                deleteAction={removeProductByIds}
                typeClose="product"
                item={featuredProductItemObj?.products || []}
                currentIdPicture={currentIdPicture}
                setShowModalImg={setShowModalImg}
                productDetails={featuredProductItemObj || {}}
                setTypeModal={setTypeModal}
                showModalImg={showModalImg}
                handleClose={handleClose}
                typeModal={typeModal}
                loading={loading}
            />

            <ModalConfirm
                title="Удалить"
                descriptionDelete
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                onClick={confirmDeleteObj}
            />
        </>
    );
};

export default FeaturedProductItem;